import { debounceSecond } from 'assets/constant';
import { CardHeader } from 'components/common';
import BoardJodit from 'components/common/board/BoardJodit';
import BreadCrumb from 'components/shared/BreadCrumb';
import { useNoticeState } from 'hooks/supporting/useNoticeState';
import { usePostSupporting } from 'hooks/supporting/usePostSupporting';
import { debounce } from 'lodash';
import { BoardFile, BoardFixed, BoardTitle, BoardType } from 'pages/supporting';
import { BoardPopupPublic } from 'pages/supporting/BoardPopupPublic';
import { useEffect } from 'react';
import { Button, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router';

export const NoticeWrite = () => {
  const navigate = useNavigate();
  const {
    noticeState,
    handleTitleChange,
    handleContentChange,
    handlePostStateChange,
    handlePostTypeChange,
    handleTopFixFlagChange,
    handleFileChange,
    resetNoticeState,
  } = useNoticeState();

  const { writeMutation } = usePostSupporting();

  const debounceHandleSubmit = debounce(async () => {
    const formData = new FormData();
    const { fileList, thumbnail, ...boardPostData } = noticeState;
    const boardPostDataJson = JSON.stringify(boardPostData);
    const boardPostDataBlob = new Blob([boardPostDataJson], { type: 'application/json' });
    formData.append('notificationCreateDto', boardPostDataBlob);

    if (fileList.length > 0)
      fileList.forEach((file) => {
        formData.append('mediaList', file);
      });
    try {
      writeMutation.mutate(formData);
      navigate('/notice');
    } catch (error) {
      console.error('error', error);
    }
  }, debounceSecond);

  const handleSubmit = (e) => {
    e.preventDefault();
    debounceHandleSubmit();
  };

  useEffect(() => {
    return () => {
      resetNoticeState();
    };
  }, []);

  return (
    <>
      <main id='main' className='main'>
        <BreadCrumb home={'/notice'} sublink={'/notice'} title={'Help Center'} subTitle={'지원센터'}>
          &nbsp;/ 공지사항 / 공지 등록/수정
        </BreadCrumb>
        <div className='card p-20'>
          <CardHeader noRightBorder={false} title='공지사항' visibleContent={false}></CardHeader>

          <Form onSubmit={handleSubmit} action='' className='write-form'>
            <BoardType value={noticeState.postType} onChange={handlePostTypeChange} />
            <BoardTitle value={noticeState.title} onChange={handleTitleChange} />
            <BoardPopupPublic value={noticeState.postState} onChange={handlePostStateChange} />
            <BoardFixed value={noticeState.topFixFlag} onChange={handleTopFixFlagChange} />
            {/* <BoardPopup /> */}
            {/* <BoardThumbnail value={noticeState.thumbnail} onChange={handleThumbnailChange} /> */}

            {/* <BoardQuill value={noticeState.content} onChange={handleContentChange} /> */}
            <BoardJodit value={noticeState.content} onChange={handleContentChange} />
            {/* <BoardCKEditor value={noticeState.content} onChange={handleContentChange} /> */}

            <BoardFile value={noticeState.fileList} onChange={handleFileChange} />

            {/* 첨부파일 */}

            <div className='d-flex align-items-center justify-content-center border-top pt-3'>
              <Button type='submit' variant='primary' className='me-2'>
                등록
              </Button>
              <Button type='button' onClick={() => navigate(-1)} variant='secondary'>
                취소
              </Button>
            </div>
          </Form>
        </div>
      </main>
    </>
  );
};
